import React, {useCallback, useRef} from 'react';
import {Text, View} from 'react-native';
import {CertificateInfo, TransactionItem} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {formatDate} from '../../../../shared/utils/formatDate';
import {numberFormatToRub} from '../../../../shared/utils/numberFormatToRub';
import {useHistoryTabStyles} from './HistoryTab.style';

interface HistoryTabProps {
  transactions?: CertificateInfo['transactions'];
  activeTruIds?: number[];
  setActiveTruIds: React.Dispatch<React.SetStateAction<number[] | undefined>>;
  onTruClick: (truId: number, refToScroll: React.RefObject<View>) => void;
}

export function HistoryTab({transactions, activeTruIds, setActiveTruIds, onTruClick}: HistoryTabProps) {
  const styles = useHistoryTabStyles();
  // const sellers = useSelector(sellersSelector());
  // const dispatch = useDispatch();
  // const mapContainerRef = useRef<View>(null);

  const columns: Column<TransactionItem>[] = [
    {
      title: 'Наименование',
      field: 'truName',
      render: (row) => <Text style={styles.colText}>{row.truName}</Text>,
      headStyles: {
        colHeadStyle: {flexBasis: '40%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '40%'},
      },
    },
    {
      title: 'Изменение баланса',
      field: 'amount',
      render: (row) => {
        return (
          <Text style={styles.colTextPrimary}>
            {['Покупка', 'Корректировка отрицательная'].includes(row.typeName) ? '-' : '+'}
            {numberFormatToRub(row.amount * row.quantity)}
          </Text>
        );
      },
      headStyles: {
        colHeadStyle: {flexBasis: '15%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '15%'},
      },
    },
    {
      title: 'Кол-во (шт)',
      field: 'quantity',
      headStyles: {
        colHeadStyle: {flexBasis: '10%'},
      },
      styles: {
        colBodyTextStyle: styles.colText,
        colBodyStyle: {flexBasis: '10%'},
      },
    },
    // {
    //   title: 'Адрес',
    //   field: 'address',
    //   headStyles: {
    //     colHeadStyle: {flexBasis: '15%'},
    //   },
    //   styles: {
    //     colBodyTextStyle: styles.colText,
    //     colBodyStyle: {flexBasis: '15%'},
    //   },
    // },
    {
      title: 'Продавец',
      field: 'sellerDepartment',
      headStyles: {
        colHeadStyle: {flexBasis: '20%'},
      },
      styles: {
        colBodyTextStyle: styles.colText,
        colBodyStyle: {flexBasis: '20%'},
      },
    },
    {
      title: 'Дата',
      field: 'dateTime',
      render: (row) => {
        return <Text style={styles.colText}>{formatDate(row.dateTime)}</Text>;
      },
      headStyles: {
        colHeadStyle: {flexBasis: '15%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '15%'},
      },
    },
  ];

  // const handleRowClick = useCallback(
  //   (row: TransactionItem) => {
  //     onTruClick(row.transactionId, mapContainerRef);
  //   },
  //   [onTruClick],
  // );

  // useEffect(() => {
  //   setActiveTruIds(undefined);
  //   dispatch(eCertificatesSlice.actions.setSellers([]));
  //   dispatch(eCertificatesSlice.actions.setDepartment(null));
  // }, []);

  return (
    <LoadableContent loading={!history}>
      <Table data={transactions} columns={columns} />

      {/* <View ref={mapContainerRef}>
        <SellersGeoMap sellers={sellers} setActiveTruIds={setActiveTruIds} />
      </View> */}
    </LoadableContent>
  );
}
